<template>
  <div id="container" class="mainBox">
    <!-- 使用 vue-baidu-map-3x 提供的 BaiduMap 组件 -->
      <nyTit pathUrl='/nongye1' />
      <div class="content">
        <!-- 左 -->
        <div class="left_txts">
          <div class="left_txts_top">
            <!--左-左-->
           <div class="left_txts_top_l">
              <!-- 溯源查询-->
             <div class="subTit1"><span>溯源查询</span></div>
             <div class="left_txts_top_l_A">
                 <div class="left_txts_top_l_A_l"><leftBar1 /></div>
                 <div class="left_txts_top_l_A_r">
                   <div class="left_txts_top_l_A_r_item" v-for="(item,index) in state.leftData2" :key="index">
                     <span><countTo :startVal="0" :endVal="item.value" :duration="1000" class="fontNum"></countTo>{{item.unit}}</span>
                     <img src="../assets/img/nysy/lj.png" />
                     <span>{{item.name}}</span>
                   </div>
                 </div>
             </div>
             <div class="left_txts_top_l_B">
                <div class="left_txts_top_l_B_item" v-for="(item,index) in 2">溯源</div>
             </div>
           </div>
<!--            左-又-->
            <div class="left_txts_top_r">
              <div class="subTit1"><span>扫码趋势分析</span></div>
              <div class="echarts"><leftBar2 /></div>
            </div>
          </div>
          <div class="left_txts_down">
            <div class="subTit1 subTit2"><span>地块溯源扫码</span></div>
            <div class="left_txts_down_d">
              <div class="down_d_sym" v-for="(item, index) in state.plant" :key="index">
                <div class="imgBg"><img :src="item.img" alt="" /></div>
                <h5>{{ item.name }}</h5>
              </div>
            </div>
          </div>
        </div>
        <!-- 中 -->
        <div class="middle_txts">
          <div class="video"></div>
        </div>
        <!-- 右 -->
         <div class="right_txts">
          <div class="right_txts_top">
            <div class="right_txts_top_left">
              <div class="subTit1"><span>生长环境评估</span></div>
              <div class="right_txts_top_left_top">
                <div class="left1 fontStyle"><span>100%</span><span>气温</span></div>
                <div class="center1 fontStyle"><span>100%</span><span>正常</span></div>
                <div class="right1 fontStyle"><span>80%</span><span>水质</span></div>
              </div>
              <div class="top_list">
                <div class="top_list_d" v-for="(item, index) in state.hjdata" :key="index">
                  <div class="sx_bg"></div>
                  <h4>{{ item.number }}{{ item.unit }}</h4>
                  <span>{{ item.name }}</span>
                </div>
              </div>
            </div>
            <div class="right_txts_top_right">
              <div class="subTit1"><span>抽检数据</span></div>
              <div class="table"><dv-scroll-board :config="state.config"/></div>
            </div>
          </div>
           <div class="right_txts_bottom">
             <div class="subTit1 subTit2"><span>销售数据</span></div>
             <div class="right_txts_bottom_info">
               <div class="txts_middle_dh">
                 <div class="txts_middle_dh_item" :class="{ xzzt: state.xsindex == index }" v-for="(item, index) in state.xsdata" :key="index" @click="tabZuowu(index)">{{ item.name }}</div>
               </div>
               <div class="echarts" v-if="state.showDiv"><rightLine /></div>
             </div>

           </div>
        </div>
      </div>

  </div>
<!--  <div class="footer">本产品由来村网提供技术支持</div>-->
</template>

<script setup>
// @ is an alias to /src
import axios from "axios";
import { useRouter } from "vue-router";
import nyTit from "@/components/nyTit.vue";
import leftBar2 from "../components/suyuan/leftBar2.vue";
import leftBar1 from "../components/suyuan/leftBar1.vue";
import rightLine from "@/components/suyuan/rightLine.vue";
import countTo from "@/components/vue-count-to/src/vue-countTo.vue";

import {
  reactive,
  toRefs,
  ref,
  onMounted,
  onUnmounted,
  computed,
  onBeforeUnmount,
  getCurrentInstance,
  defineEmits,
} from "vue";



    // const timer = ref(null);
    const router = useRouter();

    const state = reactive({
      leftData1:[],
      leftData2:[{name:"累计查询人数",value:3000,unit:"人"},{name:"累计查询次数",value:6000,unit:"次"}],
      config: {
        header: [
          '<span style="color:#fff;">抽检时间</span>',
          '<span style="color:#fff;">品种</span>',
          '<span style="color:#fff;">批次</span>',
          '<span style="color:#fff;">基数</span>',
          '<span style="color:#fff;">合格率</span>',
        ],

        data: [
          ["2024.3.1", "小麦", "20230301BATCH001", "30", "<span style='color:#00FFBA;'>100%</span>"],
          ["2024.3.1", "玉米", "20230301BATCH001", "30", "<span style='color:#00FFBA;'>100%</span>"],
          ["2024.3.1", "大豆", "20230301BATCH001", "30", "<span style='color:#00FFBA;'>100%</span>"],
          ["2024.3.1", "花生", "20230301BATCH001", "30", "<span style='color:#00FFBA;'>100%</span>"],
          ["2024.3.1", "小麦", "20230301BATCH001", "30", "<span style='color:#00FFBA;'>100%</span>"],
          ["2024.3.1", "花生", "20230301BATCH001", "30", "<span style='color:#00FFBA;'>100%</span>"],
          ["2024.3.1", "大豆", "20230301BATCH001", "30", "<span style='color:#00FFBA;'>100%</span>"],
          ["2024.3.1", "小麦", "20230301BATCH001", "30", "<span style='color:#00FFBA;'>100%</span>"],
        ],
        headerBGC:"",
        oddRowBGC: "",
        evenRowBGC: "",
        index: false,
        columnWidth: [200],
        align: ["center"],
        headerHeight:90,
        rowNum:7
      },
      plant: [
        {name: "地块1", img: require("@/assets/img/nysy/sym1.png")},
        {name: "地块2",img: require("@/assets/img/nysy/sym2.png") },
        {name: "地块3", img: require("@/assets/img/nysy/sym3.png") },
        {name: "地块4",img: require("@/assets/img/nysy/sym4.png")},
        {name: "地块5", img: require("@/assets/img/nysy/sym5.png")},
        {name: "地块6",img: require("@/assets/img/nysy/sym6.png")},
        {name: "地块1", img: require("@/assets/img/nysy/sym1.png")},
        {name: "地块2",img: require("@/assets/img/nysy/sym2.png") },
        {name: "地块3", img: require("@/assets/img/nysy/sym3.png") },
        {name: "地块4",img: require("@/assets/img/nysy/sym4.png")},
        {name: "地块5", img: require("@/assets/img/nysy/sym5.png")},
        {name: "地块6",img: require("@/assets/img/nysy/sym6.png")},
      ],
      hjdata: [
        { name: "虫害", number: 60, unit: "%"},
        { name: "病害", number: 40, unit: "%"},
        {name: "土壤状态", number: 50, unit: "%"},
        { name: "土壤成分", number: 80, unit: "%"},
      ],
      xsdata: [{ name: "玉米"}, { name: "小麦"}, { name: "大豆"}, { name: "花生"}, { name: "芝麻"}, { name: "油菜"}, { name: "马铃薯"}],
      startVal: 0,
      xsindex: 0,
      showDiv:true
    });

    // 在 onMounted 中初始化地图
    onMounted(() => {});

    // 返回上一页
    function tabZuowu(index){
      state.showDiv = false; // 点击后先隐藏div
      state.xsindex = index
      setTimeout(() => {
        state.showDiv = true; // 200ms后再重新显示div（模拟刷新）
      }, 200);
    }

    onUnmounted(() => {});
    onBeforeUnmount(() => {
      // clearInterval(timer.value);
    });

</script>
<style lang="less" scoped>
 .footer{
    width: 100%;
    height: 30px;
    line-height: 30px;
    color: #fff;
    text-align: center;
    font-size: 30px;
    position: fixed;
    bottom: 30px;
    left: 0;
    z-index: 10000;
    font-weight: bold;
    }
body {
  background-size: cover;
  line-height: 1.15;
}
::v-deep .d-play-btn {
  width: 50px !important;
  height: 50px !important;
}
::v-deep .d-player-state {
  top: 50%;
  margin-top: -25px;
}
::v-deep .d-icon {
  font-size: 20px !important;
}
::v-deep .d-player-wrap .d-player-control {
  height: 30px;
}

.mainBox {
  width: 100%;
  height: 100vh;
  position: absolute;
  overflow: hidden;
  background: url("../assets/img/gbzntyj/qixiang1/bj.jpg") no-repeat top center;
  background-size: 100% 100%;
  .content {
    width: 100%;
    height: calc(100% - 174px);
    position: absolute;
    top: 12%;
    // border: #fff 1px solid;
    display: flex;
    flex-flow: row;
    .subTit1{
      width: 100%;
      height: 130px;
      line-height: 60px;
      background: url("../assets/img/nysy/xbtd.png") no-repeat center bottom;
      color: #fff;
      font-size: 40px;
      margin: 20px auto 0;
      span{
        background: linear-gradient(to bottom, #fff 25%, #FFD791 95%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        font-weight: bold;


      }
    }
    .subTit2{
      background: url("../assets/img/nysy/xbtc.png") no-repeat left bottom;
    }
    .left_txts {
      width: 1920px;
      height: 100%;
      margin: 0 10px;
      // border: #fff 1px solid;
      display: flex;
      flex-direction: column;
      border: 1px solid;
      .left_txts_top {
        width: 100%;
        flex: 1;
        display: flex;
        .left_txts_top_l{
          display: flex;
          flex-direction: column;
          width: 900px;
          height: 100%;
          .left_txts_top_l_A{
            flex: 1;
            width: 100%;
            display: flex;
            padding: 0 50px;
            .left_txts_top_l_A_l{
              width: 300px;
              height: 100%;
            }
            .left_txts_top_l_A_r{
              width: 518px;
              display: flex;
              height: 100%;
              .left_txts_top_l_A_r_item{
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                color: #fff;
                font-size: 28px;
                img{
                  width: 100%;
                  height: 166px;
                }
                .fontNum{
                  font-size: 36px;
                  margin-right: 10px;
                }
              }
            }
          }
          .left_txts_top_l_B{
            height: 226px;
            width: 763px;
            background: url("../assets/img/nysy/left--.png") no-repeat center bottom;
            display: flex;
            justify-content: space-between;
            margin: 0 auto;
            padding: 0 30px;
            .left_txts_top_l_B_item{
              width: 332px;
              height: 138px;
              line-height: 138px;
              background: url("../assets/img/nysy/sy.png") no-repeat center bottom;
              font-size: 36px;
              color: #fff;
              padding-left: 30px;
            }
          }
        }
        .left_txts_top_r{
          flex: 1;
          display: flex;
          flex-direction: column;
        }
      }

      .left_txts_down {
        width: 100%;
        height: 766px;
        animation-delay: .8s;
        display: flex;
        flex-direction: column;
        margin-top: 20px;
        .left_txts_down_d {
          width: 100%;
          flex: 1;
          margin-top: -30px;
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          position: relative;
          padding: 50px;
          .down_d_sym {
            width: 190px;
            margin: 0 50px;
            .imgBg{
              width: 190px;
              height: 190px;
              background: url("../assets/img/nysy/syk.png") no-repeat;
              display: flex;
              align-items: center;
              justify-content: center;
              img {
                width: 140px;
                height: 140px;
              }
            }

            h5 {
              width: 100%;
              font-size: 30px;
              color: #fff;
              margin-top: 10px;
              font-weight: normal;
            }
          }
        }
      }
    }
    .middle_txts {
      flex: 1;
      height:calc(100% - 100px);
      margin: 50px 50px;
      background: url("../assets/img/nysy/jkk.png")no-repeat;
      background-size: 100% 100%!important;
      padding: 100px 60px;
      .video{
        width: 100%;
        height: 100%;
        background: #000;
      }
    }
  }
  .echarts{
    width: 100%;
    flex: 1;
  }

//右
    .right_txts {
      width: 1920px;
      height: 100%;
      margin: 0 10px;
      display: flex;
      flex-direction: column;
      .right_txts_top {
        width: 100%;
        height: 700px;
        display: flex;
        .right_txts_top_left{
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .right_txts_top_left_top{
            width: 100%;
            height: 272px;
            display: flex;
            justify-content: center;
            color: #fff;
            .left1{
              width: 357px;
              height: 233px;
              background: url("../assets/img/nysy/zby.png") no-repeat right center;
              font-size: 30px;
              line-height: 60px;
              display: flex;
              flex-direction: column;
              justify-content: center;
              text-align: left;
              padding-left: 50px;
              span:first-child{
                font-size: 60px;
                color: #38E1B0;
              }
            }
            .center1{
              width: 271px;
              height: 251px;
              background: url("../assets/img/nysy/zxy.png") no-repeat;
              font-size: 50px;
              line-height: 60px;
              padding: 56px 0;
            }
            .right1{
              width: 317px;
              height: 235px;
              background: url("../assets/img/nysy/yby.png") no-repeat;
              font-size: 30px;
              line-height: 60px;
              display: flex;
              flex-direction: column;
              justify-content: center;
              text-align: right;
              padding-right: 50px;
              span:first-child{
                font-size: 60px;
                color: #38E1B0;
              }
            }
            span{display: block;}

          }
          .top_list {
            width: 90%;
            height: 152px;
            border: #39d6c4 2px solid;
            display: flex;
            margin: 50px auto;
            background: #1D3E40;;
            .top_list_d {
              height: 100%;
              flex: 1;
              // border: #fff 1px solid;
              position: relative;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              h4 {
                font-size: 40px;
                color: #37ddad;
              }
              span {
                display: block;
                font-size: 30px;
                color: #fff;
                margin-top: 10px;
              }
              .sx_bg {
                width: 2px;
                height: 65px;
                background: url("../assets/img/nysy/dx.png") no-repeat top center;
                background-size: 100% 100%;
                position: absolute;
                right: 0;
                top: 43.5px;
              }
            }
            .top_list_d:last-child {
              .sx_bg {
                display: none;
              }
            }
          }
        }
        .right_txts_top_right{
          width: 882px;
          height: 100%;
          display:flex;
          flex-direction: column;
          padding-right: 70px;
          .table{
            width: 100%;
            flex: 1;
            margin-top: -30px;
          }
          ::v-deep .dv-scroll-board .header{
            width: 100%;
            background: url("../assets/img/nysy/cj.png") no-repeat right center;
            background-size: 100% 100%;
            font-size: 30px;
          }
          ::v-deep .row-item{
            font-size: 26px;
            background:rgba(0,150,255,.1) ;
            margin: 10px 0;
          }
        }


      }
      .right_txts_bottom{
        display: flex;
        flex-direction: column;
        width: 100%;
        flex: 1;
        .right_txts_bottom_info{
          width: 100%;
          flex: 1;
          padding: 0 70px;
          display: flex;
          flex-direction: column;
          .txts_middle_dh{
            height: 68px;
            width: 100%;
            display: flex;
            justify-content: center;
            .txts_middle_dh_item{
              width: 199px;
              height: 68px;
              line-height: 68px;
              background: rgba(53,255,210,.2);
              border: 1px solid #35FFD2;
              font-size: 28px;
              color: #fff;
              margin: 0 20px;
            }
            .xzzt{
              color: #31C59B;
            }
          }
        }
      }
      }
  }

@keyframes guangying {
  /*引用动画名称*/
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(-360deg);
  }
}
@keyframes left1Img {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes titIcon {
  /*引用动画名称*/
  0% {
    transform: rotateY(0);
  }
  50% {
    transform: rotateY(180deg);
    animation-delay: 5s;
  }
  100% {
    transform: rotateY(0);
  }
}
</style>
